/**
 * Centralized configuration for toast notifications used throughout the KYC process.
 * This ensures consistent styling and appearance across all components.
 */

// Styling for success toasts
export const successToastStyle = {
  style: {
    fontSize: '1.2rem',
    padding: '16px 24px',
    maxWidth: '500px',
    minWidth: '300px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  },
  iconTheme: {
    primary: '#10B981',
    secondary: '#FFFFFF',
  },
  duration: 4000,
};

// Styling for error toasts
export const errorToastStyle = {
  style: {
    fontSize: '1.2rem',
    padding: '16px 24px',
    maxWidth: '500px',
    minWidth: '300px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  },
  iconTheme: {
    primary: '#EF4444',
    secondary: '#FFFFFF',
  },
  duration: 5000, // Slightly longer duration for errors
};

// Styling for info toasts
export const infoToastStyle = {
  style: {
    fontSize: '1.2rem',
    padding: '16px 24px',
    maxWidth: '500px',
    minWidth: '300px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  },
  iconTheme: {
    primary: '#3B82F6',
    secondary: '#FFFFFF',
  },
  duration: 3000,
};

// Default toast configuration for the Toaster component
export const defaultToasterConfig = {
  position: 'top-right' as const,
  toastOptions: {
    duration: 4000,
    style: {
      background: '#fff',
      color: '#333',
      fontSize: '1.2rem',
      padding: '16px 24px',
      maxWidth: '500px',
      minWidth: '300px',
    },
  },
};
